import React from "react";
import { transformToHtml, getBackgroundImage } from "../../../utils/CommonUtils";

export default function TitleBar({ data }) {
  if (!data) return null;

  return (
    <div className="fsd-title-bar makeFlex hrtlCenter padding16 whiteBg br8">
      {data.airlineIcon && (
        <span
          className="fsd-airline-icon bgProperties"
          style={getBackgroundImage(data.airlineIcon)}
        />
      )}
      <div className="makeFlex hrtlCenter">
        {data.airlineCode && (
          <span className="fsd-flight-code">{transformToHtml(data.airlineCode)}</span>
        )}
        <span className="fsd-title-separator" />
        {data.airlineName && (
          <span className="fsd-airline-name">{transformToHtml(data.airlineName)}</span>
        )}
        {data.operatedBy && (
          <span className="fontSize16">{transformToHtml(data.operatedBy)}</span>
        )}
      </div>
    </div>
  );
}
